<template>
  <div class="shared_briefcase_popup_wrp">
    <div class="shared_popup_center_popup">
      <div class="shared_popup_modal">
        <div class="shared_popup_header">
          <h3 class="shared_popup_heading">Briefcase Share</h3>
          <button
            type="button"
            class="shared_popup_close"
            aria-label="Close"
            @click="closePopup"
          >
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>

        <div class="shared_popup_body">
          <form @submit.prevent="sharedBriefcaseMethod">
            <div class="form-group">
              <label for="briefcase-name">Name</label>
              <input
                id="briefcase-name"
                type="text"
                class="form-control"
                readonly
                :value="briefcaseName"
              />
            </div>

            <div class="form-group multiselect_dropdown_ui">
              <label for="select-users">User</label>
              <multiselect
                id="select-users"
                v-model="selectedUsers"
                placeholder="Select User"
                label="email"
                track-by="email"
                name="users"
                :options="userOptions"
                :option-height="104"
                :custom-label="customLabel"
                :show-labels="true"
                :multiple="true"
                :taggable="true"
                :loading="isLoadingUsers"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('users') }"
                @tag="addTag"
              />
              <small class="invalid-feedback" v-if="errors.has('users')">
                {{ errors.first('users') }}
              </small>
            </div>

            <div class="form-group mb-0">
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="isSubmitting"
              >
                {{ isSubmitting ? 'Sharing...' : 'Share' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { bus } from '@/main';
import toast from '@/services/toast';

export default {
  name: 'SharedBriefcase',
  components: { Multiselect },
  props: {
    sharedBriefcaseINFO: {
      type: Object,
      required: true,
      default: function () {
        return { id: '', name: '' };
      }
    }
  },
  data() {
    return {
      isSubmitting: false,
      isLoadingUsers: false,
      userOptions: [],
      selectedUsers: []
    };
  },
  computed: {
    briefcaseName() {
      return (this.sharedBriefcaseINFO && this.sharedBriefcaseINFO.name) || '';
    },
    briefcaseId() {
      return (this.sharedBriefcaseINFO && this.sharedBriefcaseINFO.id) || '';
    }
  },
  mounted() {
    this.fetchUsers();
  },
  beforeDestroy() {
    document.body.classList.remove('body_right_scroll_remove');
  },
  methods: {
    async fetchUsers() {
      this.isLoadingUsers = true;
      try {
        const res = await this.$store.dispatch('isConditionalListOfAllUsersFun');
        const users = (res && res.data && res.data.data) || [];
        this.userOptions = users.map(function (user) {
          return {
            id: user.id,
            first_name: user.first_name || '',
            last_name: user.last_name || '',
            email: user.email || ''
          };
        });
      } catch (err) {
        toast.error('Failed to load user list.');
      } finally {
        this.isLoadingUsers = false;
      }
    },

    addTag(newEmail) {
      const newTag = {
        id: 'custom_' + Date.now() + '_' + Math.floor(Math.random() * 1000),
        first_name: '',
        last_name: '',
        email: newEmail
      };
      this.userOptions.push(newTag);
      this.selectedUsers.push(newTag);
    },

    customLabel(user) {
      if (!user) return '';
      const firstName = user.first_name || '';
      const lastName = user.last_name || '';
      const email = user.email || '';
      const fullName = (firstName + ' ' + lastName).trim();

      return fullName ? fullName + ' (' + email + ')' : email;
    },

    async sharedBriefcaseMethod() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) return;

      this.isSubmitting = true;
      const payload = {
        briefcase_folder: this.briefcaseId,
        user: this.selectedUsers.map(function (user) {
          return user.id;
        })
      };

      try {
        const res = await this.$store.dispatch('shareBriefcaseDetailsWithUserAction', payload);
        const successMsg = (res && res.data && res.data.msg) || 'Briefcase shared successfully.';
        toast.success(successMsg);
        this.closePopup();
      } catch (err) {
        const errorMsg =
          (err && err.data && err.data.msg) ||
          (err && err.message) ||
          'Error sharing briefcase.';
        toast.error(errorMsg);
      } finally {
        this.isSubmitting = false;
      }
    },

    closePopup() {
      document.body.classList.remove('body_right_scroll_remove');
      bus.$emit('sharedBriefcasePopupStateBus', false);
      this.selectedUsers = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.shared_briefcase_popup_wrp {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.92);
  display: table;
  width: 100%;
  height: 100%;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
  color: #ffffff;

  .shared_popup_center_popup {
    display: table-cell;
    vertical-align: middle;
  }

  .shared_popup_modal {
    background: #000;
    max-width: 520px;
    margin: 0 auto;
    border-radius: 5px;
    -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
  }

  .shared_popup_close {
    position: absolute;
    top: 15px;
    right: 15px;
    line-height: 1;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;

    .fa {
      font-size: 20px;
      color: red;
      transition: color 0.3s ease;

      &:hover {
        color: #87cefa;
      }
    }
  }

  .shared_popup_header {
    padding: 15px;
    position: relative;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);

    .shared_popup_heading {
      font-size: 24px;
      letter-spacing: 0;
      margin-bottom: 0;
    }
  }

  .shared_popup_body {
    padding: 15px;

    label {
      display: inline-block;
      font-size: 16px;
      margin-bottom: 4px;
    }

    .form-control {
      height: auto;
      padding: 7px 15px;
      background: rgba(255, 255, 255, 0.1);
      border-color: transparent;
      font-size: 16px;
      color: #fff;
      font-family: inherit;
      outline: none;
      box-shadow: none;
    }

    .invalid-feedback {
      font-size: 14px;
      line-height: 1;
    }

    .btn-primary {
      cursor: pointer;
      min-width: 95px;
      box-shadow: none;
      outline: none;
      background: rgba(255, 255, 255, 0.12);
      color: #ffffff;
      border: none;
      border-radius: 3px;
      font-family: inherit;
      font-size: 18px;
      transition: background 0.2s ease, color 0.2s ease;

      &:hover:not(:disabled) {
        background: #87cefa;
        color: #22292f;
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
}
</style>